import { IConfig } from '@cian/config/shared';
import {
  PERSONAL_DATA_AGREEMENT_LINK,
  PERSONAL_DATA_CONSULTANT_CALLBACK_CONFIG_KEY,
} from '../../../../constants/links';

export const getPersonalDataAgreementUrl = (config: IConfig): string => {
  const personalDataConfig = config.getStrict<{ agreement?: string }>(PERSONAL_DATA_CONSULTANT_CALLBACK_CONFIG_KEY);

  return personalDataConfig.agreement ?? PERSONAL_DATA_AGREEMENT_LINK;
};
